import { ReactNode } from "react";

export function SignStatusIcon({
  icon,
  iconColor,
  iconBackgroundColor,
  iconSecondaryBackgroundColor,
}: {
  icon: ReactNode;
  iconColor: string;
  iconBackgroundColor: string;
  iconSecondaryBackgroundColor: string;
}) {
  return (
    <div
      style={{ background: iconSecondaryBackgroundColor }}
      className={"w-32 h-32 rounded-full flex justify-center items-center"}
    >
      <div
        style={{ background: iconBackgroundColor }}
        className={"size-24 rounded-full flex justify-center items-center"}
      >
        <span style={{ color: iconColor }} className={"text-5xl"}>
          {icon}
        </span>
      </div>
    </div>
  );
}
